import type { Accordion, GlobalFieldReference } from '@ps/web-martech-cms-types';
import { CrossIcon } from '@ps/web-shared-components';
import classNames from 'clsx';
import { upperFirst } from 'lodash';
import type { ReactElement } from 'react';
import React, { useContext } from 'react';

import { CMSReference } from '@swf/cms';
import Arrow from '@swf/core/assets/icons/arrow.svg';

import { ContainerVariantContext } from '../CMSContainer/CMSContainer';

import styles from './PanelItem.scss';

interface Props {
  body: GlobalFieldReference[];
  expanded: boolean;
  onClick: () => void;
  collapsedTitle?: string;
  expandedTitle?: string;
  element?: ReactElement;
  theme?: Accordion['theme'];
  buttonType?: Accordion['button_type'];
}

const PanelItem: React.FC<Props> = ({
  body,
  theme = 'Default',
  buttonType = 'Arrow',
  collapsedTitle,
  expandedTitle,
  expanded,
  element,
  onClick
}) => {
  const { containerVariant } = useContext(ContainerVariantContext);

  return body?.length || element ? (
    <div
      className={classNames({
        [styles[`cardLite${upperFirst(containerVariant ?? '')}` as keyof typeof styles]]:
          theme === 'Lite' && !!containerVariant,
        [styles.card]: theme === 'Default'
      })}
    >
      <div className={styles.cardHeader}>
        <button
          className={classNames(styles.cardTitleButton, {
            [styles.active]: expanded,
            [styles.cardTitleButtonStyle]: theme === 'Default',
            [styles.cardTitleButtonStyleLite]: theme === 'Lite',
            [styles[`litePanel${upperFirst(containerVariant ?? '')}` as keyof typeof styles]]:
              theme === 'Lite' && !!containerVariant
          })}
          type="button"
          onClick={onClick}
        >
          <span
            className={classNames({
              [styles.text]: theme === 'Default',
              [styles.textLite]: theme === 'Lite'
            })}
          >
            {expanded ? expandedTitle : collapsedTitle}
          </span>
          <span
            className={classNames({
              [styles.controlCross]: buttonType === 'Cross',
              [styles.controlArrow]: buttonType === 'Arrow'
            })}
          >
            {buttonType === 'Cross' ? <CrossIcon /> : <Arrow width={15} height={15} />}
          </span>
        </button>
      </div>
      <div className={classNames(styles.collapse, { [styles.show]: expanded })}>
        <div className={styles.cardBody}>
          {body?.map((item, itemIndex) => (
            <CMSReference key={itemIndex} {...item} />
          ))}
          {element && element}
        </div>
      </div>
    </div>
  ) : null;
};

export default PanelItem;
